define('model/disclosure.detail.model',['require','exports','module','underscore','./association.model','fukit','datakit/datakit','blockit'],function(require, exports, module) {
  //prettier-ignore
  var _                 = require('underscore'),
      AssociationsModel = require('./association.model'),
      BaseModel         = require('fukit').BaseModel,
      Datakit           = require('datakit/datakit'),
      BlocKit           = require('blockit');

  var DisclosureDetailModel = BaseModel.extend({
    radioRequests: {
      'models DisclosureDetail': '@constructor',
      'models DisclosureDetailModel': '@constructor',
    },

    urlRoot: '/api/v2/coi/disclosure',

    virtual: {
      reviewerNameAndDate: {
        get: function() {
          var resolveDate = BlocKit.Formatter.date({
            format: 'L',
            emptyValue: '--',
          })(this.get('finalizedDate'));

          if (this.get('disclosureReviewerUserId') == null) {
            return resolveDate + ' by Automated Action';
          } else {
            return resolveDate + ' by ' + this.get('disclosureReviewerName');
          }
        },
      },
    },

    relationships: {
      workflowTaskModel: {
        type: 'hasOne',
        foreignKey: 'documentId',
        downstreamCascadedRelationships: [
          'workflowTaskModel',
          'processInstanceModel',
          'decisionCollection',
          'assignmentDetailModel',
        ],
        resourceClass: 'WorkflowTaskModel',
      },
      processInstanceModel: {
        type: 'hasOne',
        foreignKey: 'documentId',
        resourceClass: 'WorkflowProcessInstanceModel',
      },
      assignmentDetailModel: {
        type: 'belongsTo',
        foreignKey: 'id',
        resourceClass: 'DisclosureAssignmentDetailModel',
        downstreamCascadedRelationships: ['workflowTaskModel'],
      },
      decisionCollection: {
        type: 'hasMany',
        foreignKey: 'documentId',
        resourceClass: 'DisclosureDecisionModel.Collection',
        downstreamCascadedRelationships: ['workflowTaskModel', 'decisionCollection', 'sessionDecisionModel'],
      },
      sessionDecisionModel: {
        type: 'hasOne',
        foreignKey: 'documentId',
        fetchMode: 'manual',
        downstreamCascadedRelationships: ['sessionDecisionModel', 'decisionCollection', 'workflowTaskModel'],
        resourceClass: 'CurrentUserDecisionModel',
      },
    },
    childModels: {
      disclosureOwnerUnits: AssociationsModel,
      disclosureExternalOrgList: AssociationsModel,
    },

    upstreamCascadedRelationships: ['workflowTaskModel', 'assignmentDetailModel'],

    destroy: function(options) {
      options = _.extend({}, options, {
        url: '/api/v1/compliance/disclosure/' + this.id,
      });

      BaseModel.prototype.destroy.call(this, options);
    },
  });

  module.exports = DisclosureDetailModel;
});

